import { atom } from "recoil";


const userDeleteAtom = atom({
    key: 'deleteState',
    default: false,
});
  
export default userDeleteAtom